<p-toast></p-toast>
<div class="app-verification-container">
    <p-card styleClass="p-card-shadow">
        <div class="card">
            <h4></h4>
                <p-table #dt1 [value]="Data" [rows]="16" [paginator]="true"
                [globalFilterFields]="['srNo','AppID','Village','Block','District','FarmerName','VendorName','boqComponent','EstimatedAmount','TotalBilledAmount','PhysicalyVerified','JERemarks','PlantSpacing','FarmerShareAmount','MIArea','AmtPaidByFarmer']"
                responsiveLayout="scroll"  [(selection)]="Data" [rowHover]="true" dataKey="id"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                [showCurrentPageReport]="true">
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="srNo">Sr. No.
                            <p-columnFilter type="text" field="srNo" display="menu"></p-columnFilter>
                            <p-sortIcon field="srNo"></p-sortIcon>
                        </th>

                        <th pSortableColumn="AppID">APP ID
                            <p-columnFilter type="text" field="AppID" display="menu"></p-columnFilter>
                            <p-sortIcon field="AppID"></p-sortIcon>
                        </th>

                        <th pSortableColumn="Village">Village
                            <p-columnFilter type="text" field="Village" display="menu"></p-columnFilter>
                            <p-sortIcon field="Village"></p-sortIcon>
                        </th>

                        <th pSortableColumn="Block">Block
                            <p-columnFilter type="text" field="Block" display="menu"></p-columnFilter>
                            <p-sortIcon field="Block"></p-sortIcon>
                        </th>

                        <th pSortableColumn="District">District
                            <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                            <p-sortIcon field="District"></p-sortIcon>
                        </th>

                        <th pSortableColumn="FarmerName">Father Name
                            <p-columnFilter type="text" field="FarmerName" display="menu"></p-columnFilter>
                            <p-sortIcon field="FarmerName"></p-sortIcon>
                        </th>

                        <th pSortableColumn="VendorName">Vendor Name
                            <p-columnFilter type="text" field="VendorName" display="menu"></p-columnFilter>
                            <p-sortIcon field="VendorName"></p-sortIcon>
                        </th>

                        <th pSortableColumn="boqComponent">BOQ Component
                            <p-columnFilter type="text" field="boqComponent" display="menu"></p-columnFilter>
                            <p-sortIcon field="boqComponent"></p-sortIcon>
                        </th>

                        <th pSortableColumn="EstimatedAmount">Estimate Amount
                            <p-columnFilter type="text" field="EstimatedAmount" display="menu"></p-columnFilter>
                            <p-sortIcon field="EstimatedAmount"></p-sortIcon>
                        </th>

                        <th pSortableColumn="TotalBilledAmount">Total Amount
                            <p-columnFilter type="text" field="TotalBilledAmount" display="menu"></p-columnFilter>
                            <p-sortIcon field="TotalBilledAmount"></p-sortIcon>
                        </th>

                        <th pSortableColumn="PhysicalyVerified">Physically Verified
                            <p-columnFilter type="text" field="PhysicalyVerified" display="menu"></p-columnFilter>
                            <p-sortIcon field="PhysicalyVerified"></p-sortIcon>
                        </th>

                        <th pSortableColumn="JERemarks">Remarks entered by JE
                            <p-columnFilter type="text" field="JERemarks" display="menu"></p-columnFilter>
                            <p-sortIcon field="JERemarks"></p-sortIcon>
                        </th>

                        <th pSortableColumn="PlantSpacing">Plant Spacing
                            <p-columnFilter type="text" field="PlantSpacing" display="menu"></p-columnFilter>
                            <p-sortIcon field="PlantSpacing"></p-sortIcon>
                        </th>

                        <th pSortableColumn="FarmerShareAmount">Farmer Share
                            <p-columnFilter type="text" field="FarmerShareAmount" display="menu"></p-columnFilter>
                            <p-sortIcon field="FarmerShareAmount"></p-sortIcon>
                        </th>

                        <th pSortableColumn="MIArea">MI Area
                            <p-columnFilter type="text" field="MIArea" display="menu"></p-columnFilter>
                            <p-sortIcon field="MIArea"></p-sortIcon>
                        </th>

                        <th pSortableColumn="AmtPaidByFarmer">Amount Deposited by farmer
                            <p-columnFilter type="text" field="AmtPaidByFarmer" display="menu"></p-columnFilter>
                            <p-sortIcon field="AmtPaidByFarmer"></p-sortIcon>
                        </th>

                        <!-- <th>Action</th> -->

                    </tr>

                </ng-template>

                <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                    <tr>
                        <td>{{rowIndex + 1}}</td>
                        <td>{{product.AppID}}</td>
                        <td>{{product.Village}}</td>
                        <td>{{product.Block}}</td>
                        <td>{{product.District}}</td>
                        <td>{{product.FarmerName}}</td>
                        <td>{{product.VendorName}}</td>
                        <td>{{product.boqComponent}}</td>
                        <td>{{product.EstimatedAmount}}</td>
                        <td>{{product.TotalBilledAmount}}</td>
                        <td>{{product.PhysicalyVerified}}</td>
                        <td>{{product.JERemarks}}</td>
                        <td>{{product.PlantSpacing}}</td>
                        <td>{{product.FarmerShareAmount}}</td>
                        <td>{{product.MIArea}}</td>
                        <td>{{product.AmtPaidByFarmer}}</td>
                        <!-- <td><button (click)="selectTankRowData(product)" pButton pRipple type="button"
                                label="Fill Details" class="p-button-success mr-2 mb-2"></button></td> -->
                        <td><button (click)="selectviewform(product)" pButton pRipple type="button"
                                    label="Select" class="p-button-success mr-2 mb-2"></button></td>
                    </tr>
                </ng-template>

            </p-table>
        </div>
    </p-card>
</div>

